import React from "react";
import styles from "./People.module.scss";
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import NrgPage from '../NrgPage.jsx';
import App from '../../app/App';
import ArbitraryHtmlBox from './../../components/ArbitraryHtmlBox/ArbitraryHtmlBox.jsx';
import BambooHr from './../../components/BambooHr/BambooHr.jsx';
import DocumentHead from './../../components/DocumentHead.jsx';
import CommonClientScripts from './../../components/CommonClientScripts.jsx';
import Footer from './../../components/Footer/Footer.jsx';
import GenericHeader from './../../components/Header/GenericHeader.jsx';
import JourneyContinueBox from './../../components/JourneyContinueBox/JourneyContinueBox.jsx';
import NewsPanel from './../../components/NewsPanel/NewsPanel.jsx';
import OverPipePanel from './../../components/OverPipePanel/OverPipePanel.jsx';
import PageTransitioner from '../../components/PageTransitioner.jsx';
import PeoplePopup from './../../components/PeoplePopup/PeoplePopup.jsx';
import PipedContentFooter from './../../components/PipedContentFooter/PipedContentFooter.jsx';
import PipedContentHeader from './../../components/PipedContentHeader/PipedContentHeader.jsx';
import PipedPanelConnector from './../../components/PipedPanelConnector/PipedPanelConnector.jsx';
import PeopleList from './../../components/PeopleList/PeopleList.jsx';
import SimpleTextBox from './../../components/SimpleTextBox/SimpleTextBox.jsx';
import StyledTextBox from './../../components/StyledTextBox/StyledTextBox.jsx';
import { Content as PeopleListContent } from './../../components/PeopleList/Content.js';

import ScrollItemManager from './../../utils/ScrollItemManager'
import { changePageTitle } from "../../utils/pageSetup/pageSetup";

class People extends NrgPage {
    constructor(props) {
        super(props);

        this.page = 'people';

        this.popupStore = App.peoplePopup.store;
        this.popupActions = App.peoplePopup.actions;
        this.newsStore = App.newsPanel.store;
        this.newsActions = App.newsPanel.actions;

        this.popupStore.populate(PeopleListContent.people.leaders.list);

        this.state = {
            popupPeople: this.popupStore.getCurrentPeople(),
            popupPerson: this.popupStore.getCurrentPerson(),
            popupOpen: false,
            newsOpen: false
        };

        this._onPopupPopulate = this._onPopupPopulate.bind(this);
        this._onPopupOpen = this._onPopupOpen.bind(this);
        this._onPopupUpdatePerson = this._onPopupUpdatePerson.bind(this);
        this._onPopupClose = this._onPopupClose.bind(this);
        this._onOpenNews = this._onOpenNews.bind(this);
        this._onCloseNews = this._onCloseNews.bind(this);
    }

    componentDidMount() {
        changePageTitle(this.page);

        // People popup listeners
        this.popupStore.addPopulateListener(this._onPopupPopulate);
        this.popupStore.addOpenListener(this._onPopupOpen);
        this.popupStore.addUpdateListener(this._onPopupUpdatePerson);
        this.popupStore.addCloseListener(this._onPopupClose);

        // // News panel listeners
        this.newsStore.addOpenListener(this._onOpenNews);
        this.newsStore.addCloseListener(this._onCloseNews);

        this.scrollItemManager = new ScrollItemManager()
        this.scrollItemManager.setup()
    }
    render() {
        return (
            <div className={[this.page, "container-fluid"].join(" ")}>
                <PageTransitioner page={this.page}>

                    {/* <ReactCSSTransitionGroup
                        transitionName="news"
                        transitionAppear={true}
                        transitionAppearTimeout={0}
                        transitionEnterTimeout={300}
                        transitionLeaveTimeout={300}>
                        {newsPanel}
                    </ReactCSSTransitionGroup> */}

                    <GenericHeader page={this.page} newsActions={this.newsActions} />

                    <SimpleTextBox page={this.page} />

                    <PipedContentHeader page={this.page} />
                    <OverPipePanel page={this.page} section="excellence" />
                    <PipedPanelConnector />
                    <OverPipePanel page={this.page} section="innovation" />
                    <PipedPanelConnector />
                    <OverPipePanel page={this.page} section="collaboration" />
                    <PipedPanelConnector />
                    <OverPipePanel page={this.page} section="enthusiasm" />
                    <PipedPanelConnector />
                    <OverPipePanel page={this.page} section="grit" />
                    <PipedContentFooter />

                    <ArbitraryHtmlBox page={this.page} section="join" />
                    <StyledTextBox page={this.page} />

                    <PeopleList actions={this.popupActions} people={this.state.popupPeople} />

                    <BambooHr />

                    <JourneyContinueBox nextPage="Contact" nextPageHref="/network" />
                    <Footer />

                    <PeoplePopup
                        person={this.state.popupPerson}
                        open={this.state.popupOpen}
                        actions={this.popupActions}
                        canNavigateLeft={this._canPopupNavigateLeft()}
                        canNavigateRight={this._canPopupNavigateRight()}
                    />

                </PageTransitioner>
            </div>
        );
    }
}

export default People;
